
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M214.802 428.388c-16.912 16.907-44.358 16.907-61.261 0L13.687 288.527c-16.916-16.898-16.916-44.346 0-61.25 16.904-16.915 44.346-16.915 61.261 0l101.486 101.481c4.269 4.257 11.2 4.257 15.477 0l245.137-245.14c16.907-16.915 44.354-16.915 61.269 0A43.334 43.334 0 01511 114.245a43.348 43.348 0 01-12.684 30.627L214.802 428.388z"}})])
          )
        }
      }
    